/*
 * PAWS & PEARLS — FLYING GALLEON / SECRET SKY V1 — 27 OCTOBER 2026
 * Jeeves XXVI — independent, reversible sunset silhouette layer.
 * One exact approved Photography master. WebP only removes transparent padding,
 * preserving every visible pixel (verified lossless RGBA). No extra sun or sky.
 *
 * Choreography matches Madam's approved 30s concept preview: visible width 83
 * reference pixels; x center 702 -> 1012; y top ~166; slight vertical float,
 * tilt <=0.55deg. 20s rest/clear sky between passages; fades at path ends.
 * The layer is added BEFORE current sky children at z-index 1, protecting
 * background painting (z0) and the existing balloons (z1), flocks (z2),
 * Lilla/squadron (z3) and hippo (z4). No existing nodes are modified.
 *
 * Desktop only until independently approved mobile background framing exists.
 * Geometry: 1122x1402 tall portrait background, background-size:100% auto;
 * both x AND y scale with displayed scene width, NOT sky container height.
 */
(function () {
  'use strict';
  var NS = 'ppMuseFlyingGalleonV1';
  var SKY = 'pp-muse-secret-sky';
  var ID = 'pp-muse-flying-galleon-v1';
  var STYLE = ID + '-style';
  var ASSET = 'pp-muse-flying-galleon-assets-v1';
  var SOURCE_WIDTH = 1122;
  var PASS_SECONDS = 30;
  var REST_SECONDS = 20;
  var CYCLE_SECONDS = PASS_SECONDS + REST_SECONDS;
  var START_X = 702, END_X = 1012, TOP_Y = 166, VISIBLE_WIDTH = 83;
  var TWO_PI = Math.PI * 2;
  var mounted = null;
  // Do not double-register event handlers if this script is pasted twice.
  if (window[NS] && window[NS]._ppController === ID) {
    if (typeof window[NS].refresh === 'function') window[NS].refresh();
    return;
  }
  function allowed() {
    if (!document.documentElement.classList.contains('pp-muse-secret-sky-page')) return false;
    if (!window.matchMedia || !window.matchMedia('(min-width: 768px)').matches) return false;
    var sky = document.getElementById(SKY);
    var wrapper = document.querySelector('.page-wrapper');
    return !!(sky && wrapper && wrapper.contains(sky));
  }
  function assetUrl() {
    var cfg = document.getElementById(ASSET);
    var url = cfg && cfg.getAttribute('data-galleon');
    return url && /^(https?:\/\/|\/)/.test(url) ? url : null;
  }
  function addStyle() {
    if (document.getElementById(STYLE)) return;
    var css = document.createElement('style');
    css.id = STYLE;
    css.textContent = [
      'html.pp-muse-secret-sky-page #' + SKY + ' #' + ID + '{position:absolute!important;inset:0!important;z-index:1!important;pointer-events:none!important;overflow:hidden!important;user-select:none!important;}',
      'html.pp-muse-secret-sky-page #' + ID + ' .pp-galleon-anchor{position:absolute!important;width:0!important;height:0!important;pointer-events:none!important;}',
      'html.pp-muse-secret-sky-page #' + ID + ' .pp-galleon-art{position:absolute!important;left:0!important;top:0!important;display:block!important;max-width:none!important;height:auto!important;transform-origin:50% 64%!important;will-change:transform,opacity;pointer-events:none!important;user-select:none!important;-webkit-user-drag:none!important;}',
      '@media(max-width:767px){html.pp-muse-secret-sky-page #' + ID + '{display:none!important;}}'
    ].join('');
    document.head.appendChild(css);
  }
  function scale(inst) {
    return (inst.sky.getBoundingClientRect().width || inst.sky.clientWidth) / SOURCE_WIDTH;
  }
  function update(inst) {
    var s = scale(inst);
    if (!isFinite(s) || s <= 0) return;
    var x, y, tilt, opacity, seconds = inst.elapsed / 1000;
    if (inst.reduced) {
      // Still, off to the side of the sun. Reduced-motion visitors do not see a crossing.
      x = 744; y = TOP_Y; tilt = 0; opacity = 1;
    } else {
      var t = seconds % CYCLE_SECONDS;
      if (t >= PASS_SECONDS) { opacity = 0; t = PASS_SECONDS; }
      else {
        opacity = Math.min(1, t / 2.2, (PASS_SECONDS - t) / 2.8);
      }
      x = START_X + (END_X - START_X) * (t / PASS_SECONDS);
      // identical frequency/amplitudes to the approved preview:
      y = TOP_Y + 2.1 * Math.sin(t * TWO_PI / 10.8 + 0.12) +
                  0.65 * Math.sin(t * TWO_PI / 5.4);
      tilt = 0.55 * Math.sin(t * TWO_PI / 14.5 + 0.45);
    }
    inst.anchor.style.left = (x * s).toFixed(2) + 'px';
    inst.anchor.style.top = (y * s).toFixed(2) + 'px';
    inst.img.style.width = (VISIBLE_WIDTH * s).toFixed(2) + 'px';
    inst.img.style.opacity = String(Math.max(0, opacity).toFixed(3));
    inst.img.style.transform = 'translateX(-50%) rotate(' + tilt.toFixed(3) + 'deg)';
  }
  function stop(inst) {
    if (inst.raf) window.cancelAnimationFrame(inst.raf);
    inst.raf = 0;
    inst.last = 0;
  }
  function canMove(inst) {
    return inst.ready && !inst.dead && inst.visible && !inst.reduced && !document.hidden &&
      window.matchMedia('(min-width: 768px)').matches;
  }
  function tick(inst, now) {
    inst.raf = 0;
    if (!inst.layer.isConnected || !canMove(inst)) { stop(inst); return; }
    if (inst.last) inst.elapsed += Math.min(100, Math.max(0, now - inst.last));
    inst.last = now;
    update(inst);
    inst.raf = window.requestAnimationFrame(function(n) { tick(inst, n); });
  }
  function start(inst) {
    if (inst.raf || !canMove(inst)) return;
    inst.raf = window.requestAnimationFrame(function(n) { tick(inst, n); });
  }
  function destroy() {
    var inst = mounted;
    if (!inst) return;
    inst.dead = true;
    stop(inst);
    if (inst.io) inst.io.disconnect();
    if (inst.ro) inst.ro.disconnect();
    document.removeEventListener('visibilitychange', inst.visibility);
    window.removeEventListener('resize', inst.resize);
    if (inst.motion) {
      if (inst.motion.removeEventListener) inst.motion.removeEventListener('change', inst.change);
      else if (inst.motion.removeListener) inst.motion.removeListener(inst.change);
    }
    if (inst.layer.isConnected) inst.layer.remove();
    mounted = null;
  }
  function attach() {
    if (!allowed()) { if (mounted) destroy(); return; }
    var sky = document.getElementById(SKY);
    if (mounted && mounted.sky === sky && mounted.layer.isConnected) return;
    if (mounted) destroy();
    if (document.getElementById(ID)) return;
    var url = assetUrl();
    if (!url) { console.warn('[P&P Galleon] Approved ship asset URL not found; nothing changed.'); return; }
    addStyle();
    var layer = document.createElement('div');
    layer.id = ID;
    layer.setAttribute('aria-hidden', 'true');
    layer.style.visibility = 'hidden';
    var anchor = document.createElement('span');
    anchor.className = 'pp-galleon-anchor';
    var img = document.createElement('img');
    img.className = 'pp-galleon-art';
    img.alt = '';
    img.draggable = false;
    img.decoding = 'async';
    anchor.appendChild(img);
    layer.appendChild(anchor);
    // PREPEND so other existing z=1 distant balloons stay visually above the vessel.
    sky.insertBefore(layer, sky.firstChild);
    var inst = {
      sky:sky, layer:layer, anchor:anchor, img:img, elapsed:0, last:0, raf:0,
      ready:false, visible:false, reduced:false, dead:false, io:null, ro:null,
      motion:null, visibility:null, resize:null, change:null
    };
    mounted = inst;
    inst.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    inst.reduced = !!inst.motion.matches;
    inst.visibility = function() { if (document.hidden) stop(inst); else start(inst); };
    inst.resize = function() {
      if (!window.matchMedia('(min-width: 768px)').matches) { stop(inst); }
      update(inst); start(inst);
    };
    inst.change = function(e) {
      inst.reduced = !!e.matches;
      stop(inst);
      if (inst.reduced) inst.elapsed = 0;
      update(inst);
      start(inst);
    };
    document.addEventListener('visibilitychange', inst.visibility);
    window.addEventListener('resize', inst.resize, { passive:true });
    if (inst.motion.addEventListener) inst.motion.addEventListener('change', inst.change);
    else if (inst.motion.addListener) inst.motion.addListener(inst.change);
    if ('ResizeObserver' in window) {
      inst.ro = new ResizeObserver(function() { update(inst); });
      inst.ro.observe(sky);
    }
    img.onload = function() {
      if (inst.dead || !img.naturalWidth) return;
      inst.ready = true;
      update(inst);
      layer.style.visibility = 'visible';
      if ('IntersectionObserver' in window) {
        inst.io = new IntersectionObserver(function(es) {
          inst.visible = !!(es[0] && es[0].isIntersecting);
          if (inst.visible) start(inst); else stop(inst);
        }, { threshold:0.01 });
        inst.io.observe(sky);
      } else { inst.visible = true; start(inst); }
    };
    img.onerror = function() {
      console.warn('[P&P Galleon] Approved ship asset failed to load; layer removed, other House animations unchanged.');
      destroy();
    };
    img.src = url;
  }
  window[NS] = {
    _ppController:ID,
    version:'1.0-approved-sun-crossing-30s-with-rest',
    refresh:attach,
    getStatus:function() {
      var i=mounted;
      return { installed:!!(i&&i.layer.isConnected), ready:!!(i&&i.ready),
        shipCount:i?1:0, moving:!!(i&&canMove(i)),
        artwork:'Photography approved Flying Galleon isolated silhouette',
        mapping:'1122x1402 background, reference coordinates scaled to displayed scene WIDTH',
        crossingSeconds:PASS_SECONDS, restingSeconds:REST_SECONDS,
        visibleArtWidthReferencePixels:VISIBLE_WIDTH,
        mobile:'disabled pending separately approved framing',
        modifiesExistingAnimations:false };
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach, { once:true });
  else attach();
  document.addEventListener('shopify:section:load', attach);
  document.addEventListener('shopify:section:unload', function(ev) {
    if (mounted && ev.target && (ev.target === mounted.sky || ev.target.contains(mounted.sky))) destroy();
  });
  // Also mount when Shopify's preview switches from mobile to desktop width.
  window.addEventListener('resize', attach, { passive:true });
  window.addEventListener('pageshow', attach);
})();
